import { WordpressPost } from '@benzinga/content-manager';
import { MetaProps } from '@benzinga/seo';
import { DateTime } from 'luxon';
import { formatOgImage } from '@benzinga/frontend-utils';

export const generateTargeting = (post: WordpressPost, template: string) => {
  const verticalTaxonomies = post?.taxonomies
    ?.filter(taxonomy => taxonomy.taxonomy === 'verticals')
    .map(vertical => vertical.term.name);
  const channelTaxonomies = post?.taxonomies
    ?.filter(taxonomy => taxonomy.taxonomy === 'channel')
    .map(vertical => [vertical.term.name, vertical.term.term_id].join(', '));
  const result = {
    BZ_AUTHOR: post?.meta?.author ?? '',
    BZ_CHANNEL: channelTaxonomies ?? [],
    BZ_PTYPE: template ?? '',
    BZ_TAG: verticalTaxonomies ?? [],
  };
  return result;
};

export const handleCanonicalRedirect = (canonical_link: string, slug: string, req, res): boolean => {
  const pagePath = canonical_link?.replace('https://www.benzinga.com/', '')?.replace(/\/$/, '');
  if (pagePath !== slug) {
    if (req.url) {
      const searchParams = req.url?.replace(`/${slug}`, '');

      if (typeof res.setHeader === 'function' && res.statusCode) {
        res.setHeader('Location', `/${pagePath}${searchParams}`);
        res.statusCode = 301;

        return true;
      }
    }
  }

  return false;
};

export const getVerticals = (post: WordpressPost) => {
  const verticals =
    post?.taxonomies?.filter(taxonomy => taxonomy.taxonomy === 'verticals').map(vertical => vertical.term.name) ?? [];
  return verticals;
};

export const getVerticalSlugs = (post: WordpressPost) => {
  const verticals =
    post?.taxonomies?.filter(taxonomy => taxonomy.taxonomy === 'verticals').map(vertical => vertical.term.slug) ?? [];
  return verticals;
};

export const moneyMetaInfo = (post: WordpressPost): MetaProps => {
  const canonical = post.canonical_link ?? `https://www.benzinga.com/money/${post?.slug}`;
  const zone = 'America/Detroit';
  const createdAtDate = post.meta?.publishedDate ? new Date(post.meta?.publishedDate) : null;
  const createdAtISO = createdAtDate ? DateTime.fromJSDate(createdAtDate).setZone(zone).toISO() : null;
  const updatedDate = post.meta?.modifiedDate ? new Date(post.meta?.modifiedDate) : null;
  const updatedAtISO = updatedDate ? DateTime.fromJSDate(updatedDate).setZone(zone).toISO() : null;
  const vertical = getVerticals(post);
  return {
    author: post.meta?.author ?? '',
    canonical: canonical,
    dateCreated: createdAtISO,
    dateUpdated: updatedAtISO,
    description: post.meta?.description ?? '',
    dimensions: {
      authorName: post.meta?.author ?? '',
      contentType: 'evergreen',
    },
    hrefLanguage: post.meta?.hrefLanguage ?? 'en',
    image: post.meta?.image ? formatOgImage(post.meta.image) : null,
    ogImage: post.meta?.image ? formatOgImage(post.meta.image) : null,
    ogType: 'article',
    robots: post?.robots ?? null,
    structuredData: {
      pageType: 'Article',
    },
    title: `${post.meta?.title}`,
    vertical: vertical,
  };
};
